import { useDispatch, useSelector } from 'react-redux';
import React, { useRef, useState } from 'react';
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { isEmpty } from 'lodash';

import { Dialog } from 'primereact/dialog'
import { FileUpload } from 'primereact/fileupload';

import { useUpdateMediaMutation } from '../../../../queries/folderMedia';
import { toggleDialog } from '../../../../redux/Slices/Global/globalSlice';

function UpdateMedia({ item }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { openDialog } = useSelector((state) => state.global);

    const { formState: { errors }, handleSubmit, register } = useForm({ item });
    const fileUploadRef = useRef();

    const [mediaName, setMediaName] = useState(item.file_name)
    const [thumb, setThumb] = useState({})
    const { mutate: updateMedia, isLoading } = useUpdateMediaMutation();
    const onSubmit = (data) => {

        const formData = new FormData();
        formData.append("name", data?.name);

        if (!isEmpty(thumb))
            formData.append("thumb", thumb);

        updateMedia({ mediaId: item.id, formData });
    };

    const chooseOptions = {
        className: 'upload_separator',
        label: t('media.media_click_to_upload_image'),
        style: {
            background: 'transparent',
            color: 'gray',
            width: "100%",
            border: "2px dashed #D9DEE3",
            fontWeight: "normal",
            fontSize: "13px",
            padding: "10px",

        }
    };

    const onFileSelect = (event) => {
        const file = event.files && event.files[0];

        if (file) {
            setThumb(file)
        }
    };

    const onCancelUpload = () => {
        setThumb({})
        fileUploadRef.current.clear();
    };

    return (
        <Dialog header={t('media.media_update_media')}
            visible={openDialog.updateMedia}
            onHide={() => { dispatch(toggleDialog("updateMedia")) }}
            breakpoints={{ '960px': '95vw' }}
            style={{ width: '25vw' }}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="my-5 px-4">
                    <label htmlFor="" className='fs-6 mb-1'>{t('media.media_name_label')}</label>
                    <input
                        {...register("name", { required: t('media.media_name_required') })}
                        aria-invalid={errors.name ? "true" : "false"}
                        className={errors.name ? 'form-control is-invalid fs-5' : 'form-control fs-5'}
                        placeholder={t('media.media_name_placeholder')} value={mediaName} onChange={(e) => setMediaName(e.value)}
                    />
                    {errors.name && <p className='fv-plugins-message-container invalid-feedback'>{errors.name?.message}</p>}
                </div>

                {
                    item?.type == "3D" ?
                        <div className="my-5 px-4">
                            <label htmlFor="thumbnail" className={`mb-2 form-label text-capitalize `} >{t('media.media_thumbnail_label')}</label>
                            <FileUpload
                                mode="basic"
                                name="thumbnail"
                                accept="image/*"
                                maxFileSize={1000000}
                                customUpload
                                onSelect={onFileSelect}
                                ref={fileUploadRef}
                                onClick={onCancelUpload}
                                chooseOptions={chooseOptions}
                            />
                        </div>
                        :
                        <></>
                }

                <div className="col-12 text-center d-flex  align-items-end  justify-content-center py-4 border-top border-gray">
                    <button type="reset" className="btn btn-label-secondary me-3"
                        disabled={isLoading}
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={() => dispatch(toggleDialog("updateMedia"))}>
                        {t('buttons.cancel')}
                    </button>
                    <button type="submit" className="btn btn-primary me-3" disabled={isLoading} >{t('buttons.update')}</button>
                </div>
            </form>
        </Dialog>
    )
}

export default UpdateMedia